import { render, staticRenderFns } from "./switch-bank.vue?vue&type=template&id=4e967326"
import script from "./switch-bank.vue?vue&type=script&lang=js"
export * from "./switch-bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports